<script setup>
// import { Auth } from "aws-amplify";
import { signOut } from "aws-amplify/auth";
import { onMounted } from "vue";

onMounted(() => {
  signOut();
});
</script>

<template>
  <h4>You have been signed out</h4>
</template>
